import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
    providedIn: 'root',
})
export class ErzeugungsanlagenRefreshService {

    public refreshRequested$ = new Subject<void>();

    public requestRefresh(): void {
        this.refreshRequested$.next();
    }
}
